import Vue from 'vue'
import App from './App.vue'
import router from './router'
import 'amfe-flexible'
import './assets/css/reset.css'
import VueLazyload from 'vue-lazyload'
import clipboard from 'clipboard'
//注册到vue原型上
Vue.prototype.clipboard = clipboard

import vdialog from "./components/vdialog/index"
Vue.use(vdialog);

import SlideVerify from 'vue-monoplasty-slide-verify';
Vue.use(SlideVerify);


Vue.filter('filterHtml',function(val){

    try{
        return val.replace(/<\/?.+?>/g,"");
    }catch(err){
    }
});

Vue.filter('filterInt',function(val){
    var t = Math.ceil(val)
    if (t == parseInt(val)) {
    	return parseInt(val)
    }else{
    	return val
    }
});


Vue.config.productionTip = false

//调试工具
// import eruda from 'eruda'
// eruda.init()


router.beforeEach((to, from, next) => {

    // window.token = localStorage.token ;
    // if (window.token == null || window.token == "" || typeof(window.token) == undefined) {

    //     if(to.name != 'login' && to.name != 'getCode'  && to.name != "paysuccess" && to.name != "beadhouse"){
    //         router.push({
    //             name: 'login',
    //         })
    //     }
    // }else{

    //     if(to.name == 'login' || to.name == 'getCode'){
    //         router.push({
    //             name:"index"
    //         });
    //     }
    // }
    //调用该方法,才能进入下一个钩子
    next();  
})

router.afterEach((to, from) => {

    window.scrollTo(0,0);
})

router.onError((error) => {
    const pattern = /Loading chunk .* failed/g;
    const isChunkLoadFailed = error.message.match(pattern);
    //const targetPath = router.history.pending.fullPath;
    if (isChunkLoadFailed) {
        location.reload();
    }
});

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

